import type { ChatbotLinkHandler } from "../types";

/**
 * Catch-all for absolute URLs. Mirrors the pre-registry chatbot behavior:
 * open in a new tab with `noopener,noreferrer`. Keep this last in the
 * handler list so more specific handlers get first refusal.
 */
export const externalLinkHandler: ChatbotLinkHandler = {
  id: "external",
  matches: (href) => /^https?:\/\//i.test(href),
  onClick: (href) => {
    window.open(href, "_blank", "noopener,noreferrer");
  },
};
